(function () {
  'use strict';

  var IMAGE_ATTRIBUTES = [
    'src',
    'srcset',
    'data-src',
    'data-srcset',
    'data-lazy-src',
    'data-lazy-srcset',
    'data-original',
    'data-original-src',
    'data-image',
    'data-image-src',
    'data-flickity-lazyload',
    'data-lazyload',
    'data-bg',
    'data-background-image'
  ];

  function fixWidthPlaceholder(url) {
    if (!url) return '';

    url = url.trim();

    // Convert protocol-relative URL to normal HTTPS URL
    if (url.indexOf('//') === 0) {
      url = 'https:' + url;
    }

    // Fix Boostify's invalid {width} filename
    url = url.replace(
      /_\{width\}x(?=\.(?:jpg|jpeg|png|webp|avif|gif)(?:[?#]|$))/gi,
      ''
    );

    return url;
  }

  function cleanSrcset(srcset) {
    if (!srcset) return '';

    return srcset
      .split(',')
      .map(function (candidate) {

        candidate = candidate.trim();

        if (!candidate) return '';

        var parts = candidate.split(/\s+/);

        var url = fixWidthPlaceholder(parts.shift());

        if (!url) return '';

        /*
         * Keep ONLY valid srcset descriptors:
         *
         * 180w
         * 320w
         * 768w
         * 1x
         * 2x
         *
         * Remove things such as:
         *
         * 140h
         * 219h
         */
        var descriptors = parts.filter(function (part) {
          return (
            /^\d+w$/i.test(part) ||
            /^\d*\.?\d+x$/i.test(part)
          );
        });

        return [url].concat(descriptors).join(' ');
      })
      .filter(Boolean)
      .join(', ');
  }

  function getFirstSrc(srcset) {
    if (!srcset) return '';

    var first = srcset.split(',')[0];

    if (!first) return '';

    var url = first.trim().split(/\s+/)[0];

    return fixWidthPlaceholder(url);
  }

  function isRealImageUrl(url) {
    if (!url) return false;

    return (
      url.indexOf('cdn/shop/') !== -1 ||
      /\.(jpg|jpeg|png|webp|avif|gif)(?:[?#]|$)/i.test(url)
    );
  }

  function fixImage(img) {
    if (!img || img.nodeType !== 1) return;

    /*
     * --------------------------------------------------
     * 1. Repair srcset
     * --------------------------------------------------
     */

    var srcset = img.getAttribute('srcset');

    if (srcset) {

      var fixedSrcset = cleanSrcset(srcset);

      if (fixedSrcset && fixedSrcset !== srcset) {
        img.setAttribute('srcset', fixedSrcset);
      }

    }

    /*
     * --------------------------------------------------
     * 2. Repair all lazy-loading attributes
     * --------------------------------------------------
     */

    IMAGE_ATTRIBUTES.forEach(function (attribute) {

      if (!img.hasAttribute(attribute)) return;

      var value = img.getAttribute(attribute);

      if (!value) return;

      var fixed;

      if (attribute.indexOf('srcset') !== -1) {
        fixed = cleanSrcset(value);
      } else {
        fixed = fixWidthPlaceholder(value);
      }

      if (fixed && fixed !== value) {
        img.setAttribute(attribute, fixed);
      }

    });

    /*
     * --------------------------------------------------
     * 3. Get current src
     * --------------------------------------------------
     */

    var src = img.getAttribute('src');

    /*
     * --------------------------------------------------
     * 4. If src is missing/invalid,
     *    recover it from srcset
     * --------------------------------------------------
     */

    if (
      !isRealImageUrl(src) ||
      src === '#' ||
      src.indexOf('data:image') === 0
    ) {

      var recoverySrc = '';

      /*
       * Try srcset first
       */
      var currentSrcset = img.getAttribute('srcset');

      if (currentSrcset) {
        recoverySrc = getFirstSrc(currentSrcset);
      }

      /*
       * Try lazy attributes
       */
      if (!recoverySrc) {

        var recoveryAttributes = [
          'data-src',
          'data-lazy-src',
          'data-original-src',
          'data-image-src',
          'data-flickity-lazyload'
        ];

        for (var i = 0; i < recoveryAttributes.length; i++) {

          var value = img.getAttribute(
            recoveryAttributes[i]
          );

          if (value && isRealImageUrl(value)) {
            recoverySrc = fixWidthPlaceholder(value);
            break;
          }

        }

      }

      /*
       * Set recovered image as real src
       */
      if (recoverySrc) {
        img.setAttribute('src', recoverySrc);
      }
    }

    /*
     * --------------------------------------------------
     * 5. Fix inline background image
     * --------------------------------------------------
     */

    if (img.hasAttribute('style')) {

      var style = img.getAttribute('style');

      if (style && style.indexOf('{width}') !== -1) {

        style = style.replace(
          /_\{width\}x(?=\.(?:jpg|jpeg|png|webp|avif|gif)(?:[?#]|$))/gi,
          ''
        );

        img.setAttribute('style', style);
      }
    }
  }

  function scan(root) {

    if (!root) return;

    /*
     * Root itself
     */
    if (
      root.nodeType === 1 &&
      (
        root.tagName === 'IMG' ||
        root.tagName === 'SOURCE'
      )
    ) {
      fixImage(root);
    }

    /*
     * Images inside root
     */
    var images = root.querySelectorAll
      ? root.querySelectorAll(
          'img, source'
        )
      : [];

    for (var i = 0; i < images.length; i++) {
      fixImage(images[i]);
    }
  }

  function init() {

    /*
     * Initial repair
     */
    scan(document);

    /*
     * Shopify sections and Boostify can inject
     * or modify images after page load.
     */
    if (window.MutationObserver) {

      var observer = new MutationObserver(function (mutations) {

        mutations.forEach(function (mutation) {

          /*
           * New elements
           */
          if (mutation.type === 'childList') {

            for (
              var i = 0;
              i < mutation.addedNodes.length;
              i++
            ) {

              var node = mutation.addedNodes[i];

              if (node.nodeType === 1) {
                scan(node);
              }
            }
          }

          /*
           * Image attributes changed
           */
          if (mutation.type === 'attributes') {

            if (
              mutation.target.tagName === 'IMG' ||
              mutation.target.tagName === 'SOURCE'
            ) {
              fixImage(mutation.target);
            }
          }

        });

      });

      observer.observe(
        document.documentElement,
        {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: IMAGE_ATTRIBUTES.concat([
            'style'
          ])
        }
      );
    }

    /*
     * Boostify may modify images repeatedly shortly
     * after page load.
     */
    var attempts = 0;

    var interval = setInterval(function () {

      scan(document);

      attempts++;

      if (attempts >= 30) {
        clearInterval(interval);
      }

    }, 500);
  }

  /*
   * Start
   */
  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }

})();